/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import Utilities from '../../global/Utilities';

class AddNumbers extends Component {
    fileObj = [];
    fileArray = [];

    constructor(props) {
        super(props);
        this.isEdit = false;
        this.state = {
            mobileNumbers: [],
            images: [],
            selectedFiles: [],
            addNumberVisible: false,
            fields: {
                mobileNumber: "",
            },
            isUpdate: false,
        }
    }

    async componentDidUpdate(prevProps) {
        if (prevProps?.images !== this.props?.images || prevProps?.farmerNumbers !== this.props?.farmerNumbers) {
            if (!this.state.isUpdate) {
                const { farmerNumbers, images } = this.props;
                Utilities.LogPrint("@ Images", images);
                Utilities.LogPrint("@ farmerNumbers", farmerNumbers);
                if (!this.isEdit && images != null && images?.length > 0) {

                    // let imagePro = [];
                    // for (var i = 0; i < images.length; i++) {
                    //     const arrayBufer = await SyncServices.findKrishakImageFromDatabase("key", images[i].image_name);
                    //     Utilities.LogPrint("arrayBuferarrayBufer", arrayBufer);
                    //     const imageBase64 = Utilities.arrayBufferToBase64(arrayBufer);
                    //     const imageUrl = `data:image/jpg;base64,${imageBase64}`;
                    //     let imageObject = images[i];
                    //     imageObject.path = imageUrl;
                    //     imageObject.id = images[i].krishak_image_id;
                    //     imagePro.push(imageObject);
                    // }

                    let imagePro = images.map(({ image_url: path, krishak_fellow_farmer_image_id: id, ...rest }) => ({ path, id, ...rest }));
                    Utilities.LogPrint("@ Images1", imagePro);
                    this.setState({ images: imagePro, isUpdate: true, addImageVisible: (imagePro.length < 3) });
                }

                if (farmerNumbers != null) {
                    let numbersPro = farmerNumbers.map(({ FarmerNumber: phone, ...rest }) => ({ phone, ...rest }));
                    Utilities.LogPrint("@ farmerNumbers1", numbersPro);
                    this.setState({ mobileNumbers: numbersPro, isUpdate: true });
                }

            }
        }
    }

    handleAddMobileClick = (e) => {
        e.preventDefault();
        const newArray = this.state.mobileNumbers.slice(); // Create a copy
        const mobileNumber = this._getFieldValue("mobileNumber", "");
        newArray.push({ phone: mobileNumber });
        let fields = this.state.fields;
        fields["mobileNumber"] = "";
        this.setState({ fields, mobileNumbers: newArray, addNumberVisible: false });
        //Utilities.LogPrint("mobileNumbers", newArray);
        this.props.onAddNumber(newArray);
    }

    handleValueChange = (field, e) => {
        let fields = this.state.fields;
        fields[field] = e.target.value;
        this.setState({ fields })
        const mobileNumber = this._getFieldValue("mobileNumber", "");
        this.setState({
            addNumberVisible: mobileNumber.length === 10
        });
    }

    deleteNumber = (e, item) => {
        e.preventDefault();
        const newArray = this.state.mobileNumbers.slice(); // Create a copy
        var index = newArray.indexOf(item);
        if (index !== -1) {
            newArray.splice(index, 1);
        }
        this.setState({ mobileNumbers: newArray });
        this.props.onAddNumber(newArray);
    }

    _getFieldValue(fieldName, defaultValue) {
        const { fields } = this.state;
        let value = fields[fieldName];
        if (value === null || (typeof value === 'undefined')) {
            value = defaultValue;
        }
        return value;
    }

    isExists(image) {
        const { selectedFiles } = this.state;
        return selectedFiles.some(item => item.name === image.name);
    }

    uploadMultipleImages = (e) => {
        this.fileObj = [];
        this.fileArray = this.state.images.slice();
        this.fileObj.push(e.target.files);

        const files = this.state.selectedFiles.slice();
        //const files = [];
        this.isEdit = true;
        for (let i = 0; i < this.fileObj[0].length; i++) {
            let file = this.fileObj[0][i];
            if (!this.isExists(file)) {
                const timestamp = new Date().getTime();
                var randNumber = Math.floor(1000 + Math.random() * 9000);
                var randSixDigitNumber = Math.floor(100000 + Math.random() * 900000);
                var ext = file.name.split('.').pop();

                var newFileName = randNumber + "_" + timestamp + "_" + randSixDigitNumber + "." + ext;
                file = new File([file], newFileName);

                this.fileArray.push({ path: URL.createObjectURL(file), image_name: newFileName, id: "" });
                files.push({ file, name: newFileName });
                //this.fileArray.push(URL.createObjectURL(this.fileObj[0][i]));
                //files.push(this.fileObj[0][i]);
            }
        }

        this.setState({
            images: this.fileArray,
            selectedFiles: files
        }, () => {
            this.props.onAddNumberImages(this.fileArray, this.state.selectedFiles);
        });
        e.target.value = null;
    }

    fileToByteArray(file) {
        return new Promise((resolve, reject) => {
            try {
                let reader = new FileReader();
                let fileByteArray = [];
                reader.readAsArrayBuffer(file);
                reader.onloadend = (evt) => {
                    if (evt.target.readyState === FileReader.DONE) {
                        //  fileByteArray = evt.target.result
                        const array = new Uint8Array(evt.target.result);

                        for (var i = 0; i < array.length; i++) {
                            fileByteArray.push(array[i]);
                        }

                    }
                    resolve(fileByteArray);

                }
            }
            catch (e) {
                alert("Choose a File");
                reject("Choose a File");
            }
        })
    }

    deleteImage = (item) => {
        const items = this.state.selectedFiles.filter(item => item.name !== item?.name);
        var array = [...this.state.images]; // make a separate copy of the array
        var index = array.indexOf(item);
        if (index !== -1) {
            array.splice(index, 1);
            this.setState({ images: array, selectedFiles: items });
            this.props.onAddNumberImages(array, items);
            this.props.onDeleteImageApi(item);
        }

        //this.setState({ items: items });
    }

    render() {
        const { mobileNumbers, addNumberVisible, images } = this.state;
        const mobileNumber = this._getFieldValue("mobileNumber", "");

        //Number Chips
        const mobileNumbersItem = mobileNumbers.map((number, i) => {
            return (
                <li key={i}>
                    <span>{number.phone}</span>
                    <a><i className="customic ic-close" onClick={(e) => this.deleteNumber(e, number)}></i></a>
                </li>
            )
        });

        const imageItem = images.map((image, i) => {
            return (
                <div className="col-4 image-info img-close-btn" key={i}>
                    <img src={image.path} alt="" />
                    <a onClick={() => this.deleteImage(image)}><i className="customic ic-close"></i></a>
                </div>
            )
        });

        return (
            <div className="form-group" >
                <label className="font-weight-medium d-flex align-items-center">Add Farmer Mobile Number </label>
                <div className="d-flex align-items-center">
                    <input type="number" className="form-control max-w-360" placeholder="" maxLength="10" value={mobileNumber}
                        onChange={this.handleValueChange.bind(this, "mobileNumber")} />

                    {/* <i className="customic ic-click-photo"></i> */}
                    <i className="customic ic-click-photo">
                        <input type="file" className="camera-input" onChange={this.uploadMultipleImages} multiple />
                    </i>

                    <a href="" className={addNumberVisible ? "ml-2 mt-2" : "d-none"}>
                        <i className="customic ic-add ic-20" onClick={this.handleAddMobileClick}></i></a>
                </div>

                {/* Numbers */}
                <div className="pills-list desktop mt-md-3">
                    <ul>
                        {mobileNumbersItem}
                    </ul>
                </div>

                {/* Images */}
                <div className="row">
                    <div className="col-lg-5">
                        <div className="row row7-5">
                            {imageItem}

                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

export default AddNumbers;
